import { COMMON_CONSTANTS } from '../pages/constants/commonConstants';
import { CommonModule } from './apiModules/CommonPageModules';

export class NetworkLayer {
  constructor() {
    this.baseUrl = COMMON_CONSTANTS.BASE_URL;
    this.httpHeaders = COMMON_CONSTANTS.HTTP_HEADERS;
    this.commonModule = new CommonModule(this.baseUrl, this.httpHeaders);
  }

  amlsCommonUnifiedAlertsAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonUnifiedAlertsAPI(payload);

  amlsCommonUnifiedAlertsPreventionAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonUnifiedAlertsPreventionAPI(payload);

  amlsCommonKYCAlertsAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonKYCAlertsAPI(payload);

  amlsCommontrmTypologiesActionsAPI = async (payload) =>
    await this.commonModule.fetchTypologiesActionsAPI(payload);

  amlsCommonKYCAlertsDownloadAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonKYCDownloadAlertsAPI(payload);

  amlsCommonAlertDetailsAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonAlertDetailsAPI(payload);

  amlsCommonAlertPartyIdentityAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonAlertPartyIdentityAPI(payload);

  amlsCommonAlertAssocCustomersAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonAlertAssocCustomersAPI(payload);

  amlsCommonGetTicketsAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonGetTicketsAPI(payload);

  amlsCommonApproveAndRejectTicketAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonApproveAndRejectTicketAPI(payload);
  amlsCommonAlertPartyUpdateAPI = async (payload) =>
    await this.commonModule.updateAMLSCommonAlertPartyAPI(payload);

  amlsCommonSandboxUI = async (payload) =>
    await this.commonModule.fetchAMLSCommonSandboxUI(payload);

  amlsCommonGetDynamicPropertiesCategoriesAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonGetDynamicPropertiesCategoriesAPI(
      payload
    );

  amlsCommonGetDynamicPropertiesAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonGetDynamicPropertiesAPI(payload);

  amlsCommonPutDynamicPropertiesUpdateAPI = async (moduleId, payload) =>
    await this.commonModule.updateAMLSCommonPutDynamicPropertiesAPI(
      moduleId,
      payload
    );

  amlsCommonGetPipelinesAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonGetPipelinesAPI(payload);

  amlsCommonPostPipelinesRunAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonPostPipelinesRunAPI(payload);

  amlsCommonPostPipelinesScheduleAPI = async (payload) =>
    await this.commonModule.postAMLSCommonPostPipelinesScheduleAPI(payload);

  amlsCommonPostPipelinesUnScheduleAPI = async (payload) =>
    await this.commonModule.postAMLSCommonPostPipelinesUnScheduleAPI(payload);

  amlsCommonGetPipelinesScheduleInfoAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonGetPipelinesScheduleInfoAPI(payload);

  amlsCommonGetPipelinesHistoryAPI = async (id, payload) =>
    await this.commonModule.fetchAMLSCommonGetPipelinesHistoryAPI(id, payload);

  amlsCommonPostPipelineStopAPI = async (payload) =>
    await this.commonModule.postAMLSCommonPostPipelineStopAPI(payload);

  amlsCommonBlackListAPI = async (payload) =>
    await this.commonModule.fetchBlackList(payload);

  amlsCommonGetNotificationsAPI = async (payload) =>
    await this.commonModule.fetchAMLSCommonGetNotificationsAPI(payload);
}
